<label
    class="cb-field-label"
    [ngClass]="{
        'cb-required': required,
        'cb-error': required && value && value.length < 1 && touched
    }"
    >{{ label }}</label
>
@if (!readonly) {
    <mat-selection-list
        *cbWaitFor="options"
        [name]="name"
        [(ngModel)]="value"
        [required]="required"
        [disabled]="disabled"
        (selectionChange)="onSelection()"
        [cbRequireSelectionListCheckedValidator]="required"
        [compareWith]="selectComparator.compareSelectOptions"
        [ngStyle]="{ 'max-height': maxHeight }"
    >
        @for (option of options$ | async; track option) {
            <mat-list-option
                [value]="
                    valueProp
                        ? valueProp == WHOLE_OPTION_VALUE_PROP
                            ? option
                            : option[valueProp]
                        : option.id || 0
                "
                [togglePosition]="checkboxPosition"
            >
                @if (option.isActive === false && strikeThroughInactive) {
                    <s class="cb-disabled">
                        {{ optionLabel(option) }}
                    </s>
                } @else {
                    <span class="option-label">
                        {{ optionLabel(option) }}
                    </span>
                }
            </mat-list-option>
        }
    </mat-selection-list>
}
@if (readonly) {
    <div class="flex-col">
        @for (option of options$ | async; track option) {
            <mat-checkbox
                [ngClass]="{ 'read-only': readonly, 'mat-form-field': !slim }"
                [checked]="isChecked(option['id'])"
                [disableRipple]="true"
                [disabled]="true"
            >
                {{ optionLabel(option) }}
            </mat-checkbox>
        }
    </div>
}
